import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
export var sendNotification = function sendNotification(notification) {
  return new Promise(function (resolve, reject) {
    if (!notification) reject();
    var options = {
      icon: notification.icon,
      renotify: true,
      body: notification.message,
      tag: notification.conversationID
    };
    var notif = new Notification(notification.title, options);
    notif.onclick = function (event) {
      window.focus();
      notif.close();
      var redirectURL = "/mensajes/".concat(event.srcElement.tag);
      if (window.location.pathname !== redirectURL) {
        window.location.assign(redirectURL);
      }
    };
    notif.addEventListener('show', function () {
      setTimeout(resolve, 2000, notif);
    });
  });
};